<script lang="ts">
    import {
        Marker,
        Popup,
        Tooltip
    } from "../svelteLeafletWrapper";
    import Logo from "./Logo.svelte";
    import {point2LatLngForMarker} from "../latlngCalc"
    import DivIcon from "./DivIcon.svelte";
    import {userMarkerSmall} from "./divMarkerDefine";

    export let ship: Ship;
</script>
<Marker latLng={point2LatLngForMarker(ship.coordinate_x, ship.coordinate_y)}>
    <DivIcon options={userMarkerSmall}/>
    <Popup options={{"minWidth": 200}}>
        <div>座標: { ship.coordinate_x } x {ship.coordinate_y }</div>
        <Logo name="{ ship.callsign } {ship.name}"/>
    </Popup>
    <Tooltip>({ ship.coordinate_x } x {ship.coordinate_y }) { ship.callsign } {ship.name}</Tooltip>
</Marker>

